import { src } from '../../../constants'
import { PatAttributes } from '../../../types/patient.types'
import { Avatar, Box, Text } from 'grommet'
import moment from 'moment'
import { ReactNode } from 'react'
import { SmallText } from '../Text'

export { getEncounterLocation } from './location'

type Props = {
  patient?: {
    attributes: Pick<PatAttributes, 'first_name' | 'last_name' | 'date_of_birth' | 'ref'> & { gender?: string }
  }
  location?: string
  onNameClick?: () => void
  children?: ReactNode
}

// Patient identity block shown in chart and encounter headers:
//   Amara Okafor · 47y · F
//   AMOKDE4AF676 · 12/04/1979 · Ward 3 · Room 4 · Bed 12   (location only inside an encounter)
export const PatientBanner = ({ patient, location, onNameClick, children }: Props) => {
  const attrs = patient?.attributes
  const dob = attrs?.date_of_birth ? moment(attrs.date_of_birth, 'YYYY-MM-DD') : undefined
  const sex = attrs?.gender?.charAt(0).toUpperCase()
  const name = [attrs?.first_name, attrs?.last_name].filter(Boolean).join(' ')
  const age = dob && `${moment().diff(dob, 'years')}y`
  const title = [name, age, sex].filter(Boolean).join(' · ')
  const details = [attrs?.ref, dob?.format('DD/MM/YYYY'), location].filter(Boolean).join(' · ')

  return (
    <div className="flex min-w-0 items-start gap-3">
      <Avatar size="40px" src={src} />
      <Box className="min-w-0" gap={'4px'}>
        {onNameClick ? (
          <button className="text-left hover:underline" onClick={onNameClick} title="View demographics" type="button">
            <SmallText className="capitalize">{title}</SmallText>
          </button>
        ) : (
          <SmallText className="capitalize">{title}</SmallText>
        )}
        {details && <Text size="14px">{details}</Text>}
        {children}
      </Box>
    </div>
  )
}
